module.exports = {"130627100":"仁厚镇","130627101":"王京镇","130627102":"高昌镇","130627103":"北罗镇","130627104":"白合镇","130627105":"军城镇","130627106":"川里镇","130627107":"长古城镇","130627108":"罗庄镇","130627201":"都亭乡","130627202":"南店头乡","130627203":"北店头乡","130627205":"雹水乡","130627206":"大洋乡","130627207":"迷城乡","130627208":"齐家佐乡","130627209":"羊角乡","130627210":"石门乡","130627211":"黄石口乡","130627212":"倒马关乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130627.json
// module id = 145
// module chunks = 0